
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import banner from '../pics/banner.PNG';
import Select from 'react-select';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAllCustomerOrders, getOrderStatuses, getAllOrderStatuses, formatDate, getAllSubscriptions } from '../Utils/Utils';
import { Ordertable } from '../Ordertable/Ordertable';
import { LoadingPage } from '../Loadingpage/Loadingpage';
import { initPushNotifications } from '../../services/notificationService';
import { LayoutDashboard, Menu, User, Power, Plus, Shirt, Layers, Sparkles, Truck, CircleDollarSign, ChevronRight } from 'lucide-react';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import Pusher from 'pusher-js';
//import WebSocket from 'ws';
import axios from 'axios';

import {
    useReactTable,
    getCoreRowModel,
    getPaginationRowModel,
    flexRender,
} from '@tanstack/react-table'

//const WebSocket = require('ws');

// Add this at the top of Uat.js, above your class declaration
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

class Uat extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        const webpush = require('web-push');
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            servicedate: new Date(),
            mycomments: '',
            loadweights: '',
            mobilePhone: '',
            address: '',
            totalamount: '0.00',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            token: "",
            role: "",
            address: "",
            city: "",
            area: "",
            userid: "11",
            allCustomerOrders: [],
            allorderstatuses: [],
            orderCount: 0,
            page: 'allOrders',
            lastorderstatus: '',
            pricelists: [],
            foldlist: [],
            prices: [],
            searchTerm: '',
            isLoading: true,
            allsubscriptions: [],
            deviceToken: '',
            connectionStatus: 'Connecting...',
            dynamicData: 'JBBBBBB',


        };
        const socket = null;

        // Attach Firebase onMessage foreground handler
        onMessage(this.messaging, (payload) => {
            console.log("Foreground message received:", payload);

            // 1. Safely extract notification content
            const title = payload.notification?.title || payload.data?.title || "iWash Laundry Notification";
            const body = payload.notification?.body || payload.data?.body || "Please note that your order status has changed, please login and track order to see the new status!";
            const icon = "/iwash-logo.png";

            // 2. Prevent "Notification undefined" crash
            if (typeof window !== "undefined" && "Notification" in window) {
                if (Notification.permission === "granted") {
                    try {
                        new Notification(title, { body, icon });
                    } catch (error) {
                        console.error("Failed to display native notification:", error);
                    }
                } else {
                    console.warn("Notification permission not granted.");
                }
            } else {
                console.warn("This browser context does not support the Notification API.");
                // Fallback: Alert or UI toast notification
                alert(`${title}: ${body}`);
            }
        });

    }
    orderstats = []
    strStat = ''
    foldlist = []
    vapidPublicKey = 'BDlu-cTVRPmTgaAi1UeNJUwUERfCTC9QKPed497WcUG7gh5WWXyxx5_Q3LlNW6VggFVk_s4Ae9h1r_ZbGcv1tzE';

    // Generate keys once and save them in environment variables
    // npx web-push generate-vapid-keys
    /////////////////////////////////////////////////////////////
    // 1. Copy your exact Web Configuration credentials from the Firebase Console General Tab
    firebaseConfig = {
        apiKey: "AIzaSyA-s0TGFcE_sIPV6YSjNJk8clTPiMCz7UU",
        authDomain: "iwash-laundry-2d327.firebaseapp.com",
        projectId: "iwash-laundry-2d327",
        storageBucket: "iwash-laundry-2d327.firebasestorage.app",
        messagingSenderId: "361330789184",
        appId: "1:361330789184:web:106c241e45f338be0c08a5"
    };

    app = initializeApp(this.firebaseConfig);
    messaging = getMessaging(this.app);
    isEnrollingNotification = false;

    // 2. Clear mobile device cache and save fresh registration tokens to MySQL
    async forceFreshMobilePushSubscription(currentUserId) {
        if (this.isEnrollingNotification) return;

        try {
            this.isEnrollingNotification = true;

            // 1. HARD WIPE: Check for any existing service workers and force unregister them
            if ('serviceWorker' in navigator) {
                const activeRegistrations = await navigator.serviceWorker.getRegistrations();


                for (let reg of activeRegistrations) {
                    console.log("Found conflicting service worker thread. Force unregistering...");
                    await reg.unregister(); // This completely drops any locked browser server keys
                }
            }

            // 2. RE-REGISTER: Register a completely clean instance of your service worker file
            console.log("Registering clean service worker instance...");
            const freshRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

            // Ensure the service worker is active and listening
            await navigator.serviceWorker.ready;

            // 3. GENERATE TOKEN: Let Firebase execute a clean token handshake
            const deviceToken = await getToken(this.messaging, {
                vapidKey: "BDlu-cTVRPmTgaAi1UeNJUwUERfCTC9QKPed497WcUG7gh5WWXyxx5_Q3LlNW6VggFVk_s4Ae9h1r_ZbGcv1tzE",
                serviceWorkerRegistration: freshRegistration
            });

            this.setState({ deviceToken: deviceToken })

            if (deviceToken) {
                console.log("Firebase cleanly generated mobile token:", deviceToken);

                // 4. DATABASE WRITE: Post the raw token to your corrected PHP save file
                const response = await axios.post(`https://testmembership.bktsystems.com/api/UAT_saveSubscription.php`, {
                    endpoint: deviceToken,
                    body: deviceToken,
                    userid: currentUserId
                });
                // console.log('---', response.data);

                console.log("Database Sync Server Response Details:", response.data);
            }

        } catch (error) {
            console.error("Mobile subscription enrollment dropped safely:", error);
        } finally {
            this.isEnrollingNotification = false;
        }

    }
    // 3. The Client Broadcast Trigger (Bypasses the broken PHP cURL layer entirely)
    async broadcastStatusNotificationToMobile(targetUserId, orderStatusText) {
        try {
            // A. Fetch the fresh active token array stored in your MySQL DB via a simple database query script
            const dbResponse = await axios.get(`https://testmembership.bktsystems.com/api/UAT_saveSubscription.php/${targetUserId}`);
            const targetToken = dbResponse.data.token; // Extracts token matching user 11

            if (!targetToken) return;

            // B. Send the request straight to the mobile network from the browser client window layer. 
            // This bypasses your hosting firewall completely.
            const fcmClientPayload = {
                message: {
                    token: targetToken,
                    notification: {
                        title: "iWash Laundry Notification!",
                        body: `Please note that your order status has been updated to ${orderStatusText}`
                    }
                }
            };

            // Use standard fetch directly to Google's public cloud architecture from the client browser thread context
            await axios.get(`https://googleapis.com/${this.firebaseConfig.projectId}/messages:send`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    // Note: For client broadcasts, map your runtime configuration definitions or use a Pusher instance channel gateway link
                },
                body: JSON.stringify(fcmClientPayload)
            });

            console.log("Notification safely pushed via client channel pipeline layer.");
        } catch (err) {
            console.error("Client transmission failed:", err);
        }
    }

    sendPushNotiff = async () => {
        let allsubs = await await getAllSubscriptions();
        console.log("Active Subscriptions:", allsubs);

        if (!this.state.allsubscriptions || !allsubs.data) {
            console.warn("No active subscription data available.");
            return;
        }

        const targetSubscriptions = allsubs.data.filter(subs => subs.userid === '11');

        if (targetSubscriptions.length === 0) {
            console.warn("No subscription found matching User ID 11.");
            return;
        }

        for (const subs of targetSubscriptions) {
            console.log('Routing to device token: ', subs.device_token);

            try {
                //  const localBackendUrl = "http://localhost/iwash-php/api/send_push.php";
                const localBackendUrl = "https://testmembership.bktsystems.com/api/send_push.php";

                const localPayload = {
                    device_token: this.state.deviceToken,
                    firebase_server_key: '' // Pass it if your backend doesn't store it
                };

                const config = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };

                // This hits YOUR server, which you control and can add CORS headers to
                const r_response = await axios.post(localBackendUrl, localPayload, config);
                console.log("Detailed Backend Diagnostics:", r_response.data);


            } catch (error) {
                console.error("Direct browser client broadcast channel failed:", error);
            }
        }

    }


    ///////////////////////////////////////////////////////////
    // Connect to the WebSocket port (not the HTTP port)
    setupWebSocket = () => {
        // 1. Establish the connection to the Node.js server
        const SERVER_URL = "ws://bktsystems.com:8282";

        //  This is correct
        this.socket = new WebSocket(SERVER_URL);

        // Listen for connection open
        this.socket.addEventListener('open', (event) => {
            console.log('Connected to the server!');
            this.socket.send(JSON.stringify({ message: 'Hello Server!' }));
        });

        // 2. Listen for incoming broadcast messages from the server
        this.socket.addEventListener('message', (event) => {
            console.log('Message from server: ', event.data);

            try {
                const data = JSON.parse(event.data);

                // If the server tells us the admin updated data, trigger your UI update
                if (data.action === 'REFRESH_YOUR_DATA') {
                    console.log('Admin updated data! Re-fetching fresh information...');


                    // Call your data fetching function here (e.g., this.fetchLatestData())
                }
            } catch (e) {
                // Handle plain text fallback messages
            }
        });

        // Handle errors
        this.socket.addEventListener('error', (event) => {
            console.error('WebSocket error observed:', event);
        });
    }


    handleSendMessage = async () => {
        try {
            // Direct HTTP POST call to your live PHP script
            const response = await fetch(`https://testmembership.bktsystems.com/api/update_data.php/${Date.now()}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    admin_action: 'trigger_update',
                    timestamp: Date.now()
                })
            });

            const result = await response.json();
            console.log('PHP Script finished execution:', result.status);
            //if(result.status ==='complete'){
           //     this.setState({dynamicData: 'Josh was here'})
            //}

        } catch (error) {
            console.error('Error executing update_data.php:', error);
        } finally {
            this.setState({ isUpdating: false });
        }        

    }

    //////////////////////////////////////////////////////////////
    getPriceList = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry", "pricelist": "washdryfold" }
        }
        // const url = "http://localhost/iwash-php/api/UAT_getPriceList.php";
        const url = "https://testmembership.bktsystems.com/api/UAT_getPriceList.php";
        // const url = "https://testmembership.bktsystems.com/api/getPriceList.php";
        const response = await axios.get(url, config);

        const wasdryfoldlist = response.data.weightlist;
        const wasdryfoldprice = response.data.washdryfoldprice;

        try {
            // 2. Convert the text string into a real JavaScript array
            const parsedwasdryfoldlist = new Function(`return ${wasdryfoldlist};`)();

            // 3. Save the actual array to your state
            this.setState({ foldlist: parsedwasdryfoldlist, prices: response.data.washdryfoldprice });
        } catch (error) {
            console.error("Failed to parse JSON string:", error);
            this.setState({ foldlist: [], prices: [] }); // Fallback to empty array if parsing fails
        }
        // console.log("Pricelist details response: " + wasdryfoldprice);
        return response.data;
    }

    componentDidMount = async () => {

        console.log('userSub token:', localStorage);
        let strOrders = await getAllCustomerOrders("11");

        await this.forceFreshMobilePushSubscription('11')

        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        let allSubscriptions = await getAllSubscriptions() || [];
        ///////////////////////
        // 1. Listen for real-time changes using Pusher
        this.pusher = new Pusher('3aecc72fdbc50572baa6', {
            cluster: 'mt1'
        });

        const channel = this.pusher.subscribe('iWash-laundry-631');

        channel.bind('admin-updated', (data) => {
            console.log('Notification received from Pusher! Refreshing UI...', data);
            this.setState({dynamicData: 'Josh was here'})
           // this.fetchLatestData(); // Automatically fetch fresh data when signaled
        });
        ///////////////////////

        //  console.log(allSubscriptions)
        let userSubsfound = ''


        // console.log("All subscriptions: ", userSubsfound);
        this.setState({ isLoading: false });
        // if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
        //   this.setState({ shouldRedirect: true });
        //}
        // else {
        this.setState({
            fullname: 'Jean Bruno', emailaddress: 'king.jeanbruno@gmail.com',
            phonenumber: '0722903449', role: 'Admin', address: '123 Main Street', area: 'Downtown', city: 'Nairobi',
            userid: "11", allCustomerOrders: await getAllCustomerOrders("11"), allorderstatuses: await getAllOrderStatuses(), pricelists: await this.getPriceList(),
            allsubscriptions: allSubscriptions
        })

        if (strOrders.includes('no data')) {
            this.setState({ orderCount: 0 });
        }
        else {
            this.setState({ orderCount: strOrders.length });
        }

    }

    getLastOrderStatus = (orderid) => {
        let lastStatus = 'Submitted'
        if ((this.state.allorderstatuses.length !== 0) && (Array.isArray(this.state.allorderstatuses))) {
            for (let i = 0; i < this.state.allorderstatuses.length; i++) {
                if (this.state.allorderstatuses[i].orderid === orderid) {
                    lastStatus = this.state.allorderstatuses[i].status
                    break
                }
            }
            //  console.log(this.state.allorderstatuses)                        
        }
        return lastStatus
    }
    setClothingWeightsChange = (currentWeight) => {
        const prices = JSON.parse(this.state.prices);
        const currentPrice = prices[currentWeight];
        console.log('Current weight selected: ' + currentPrice);

    };

    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/menu', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city, userid: this.props.location.state.userid
            }
        });
    }
    ///////////////////////////////////////////
    setSearchTerm = (e) => {

        if (e.target.value.trimEnd() === '' || e.target.value.trimStart() === '') {
            this.componentDidMount();
            return;
        }
        // const searchResult = this.state.allCustomerOrders.filter(order => {
        //     return order.id.includes(e.target.value.trimStart()) || order.fullname.toLowerCase().includes(e.target.value.toLowerCase());
        // });
        const searchResult = this.state.allCustomerOrders.filter(order => {
            return ((order.modified).slice(0, 10)).includes(e.target.value)
        });
        // searchResult.sort((a, b) => new Date(b.servicedate) - new Date(a.servicedate));    
        this.setState({ searchTerm: e.target.value, allCustomerOrders: searchResult });
    }

    clearSearchTerm = (e) => {
        if (e.key === 'Backspace' && this.state.searchTerm.length === 1) {
            this.setState({ searchTerm: '' });
            this.componentDidMount();
        }
    }

    enablePushNotif = async (userid) => {

        const registration = await navigator.serviceWorker.ready;
        // console.log('Push subscription:', registration);
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            // Your public VAPID key must be converted to a Uint8Array
            applicationServerKey: urlBase64ToUint8Array('BO6LW2MiH3sa5h8qMp79D7-m-AcpWX964itgiaNByg6WBPdpjOycIDNrBJ2L23R07DtycdZg6Oj4G_dInLPstFI')
        });

        try {
            let config = {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    body: JSON.stringify(subscription),
                    userid: userid
                }
            };
            //  console.log(config.params)
            // 4. Send subscription payload to your backend database
            // const url = "http://localhost/iwash-php/api/saveSubscription.php";
            const url = "https://testmembership.bktsystems.com/api/UAT_saveSubscription.php";
            //  const url = "https://testmembership.bktsystems.com/api/saveSubscription.php";
            const response = await axios.get(url, config);
            //  console.log(response.data);
        }
        catch (error) {
            console.error('Push registration failed:', error);
        }

    }
    sendPushNotif = async () => {
        try {

            if (Notification.permission !== "granted") {
                const permission = await Notification.requestPermission();
                if (permission !== "granted") {
                    alert("You must allow notifications in your browser settings to test this!");
                    return;
                }
            }
            let config = {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    title: 'New Notification!',
                    message: 'You have a new message from iwash-laundry.'
                }
            };
            // const url = "http://localhost/iwash-php/api/sendNotification_.php";
            const url = "https://testmembership.bktsystems.com/api/UAT_sendNotification.php";
            // const url = "https://testmembership.bktsystems.com/api/sendNotification_.php";

            // 1. Send text content safely using a POST request body
            const response = await axios.get(url, config);

            console.log('Notification broadcast response:', response.data);
            //  alert('Server processing notifications!');
            if (response.data.success) {
                //  const url = "http://localhost/iwash-php/api/sendNotification.php";
                const titleText = 'iWash-Laundry New Notification!';
                const messageText = 'You have a new message from iwash-laundry.';
                // Check if service worker is active to display standard system banners
                if ('serviceWorker' in navigator && 'serviceWorker' in navigator) {
                    console.log("Triggering local notification banner...");

                    const options = {
                        body: messageText,
                        icon: window.location.origin + '/public/iwash-logo.png', // Must be an absolute URL for Chrome
                        badge: window.location.origin + '/public/iwash-logo.png',
                        tag: 'iwash-alert-' + Date.now(), // Unique tag forces a fresh banner to pop up
                        requireInteraction: true // Prevents Chrome from hiding it instantly
                    };

                    // Instantiate directly on the window context to completely bypass the sw.js file
                    const localNotification = new Notification(titleText, options);

                    localNotification.onclick = function (event) {
                        event.preventDefault();
                        window.focus();
                        localNotification.close();
                    };
                }
            }

        } catch (error) {
            console.error('Push notification trigger failed:', error);
        }

    }
    ////////////////////////////////////////////////////

    ////////////////////////////////////////////

    render() {
        if (this.state.isLoading) {
            return <LoadingPage />;
        }
        return (

            // <div className="max-w-md mx-auto bg-slate-50 min-h-screen shadow-xl flex flex-col justify-between font-sans overflow-hidden relative pb-6">
            //     {/* Decorative background water droplets patterns */}
            //     <div className="absolute bottom-4 left-4 text-teal-200 opacity-40 pointer-events-none select-none text-xl">💧💧💧</div>
            //     <div className="absolute bottom-4 right-4 text-teal-200 opacity-40 pointer-events-none select-none text-xl">🧵</div>

            //     <div>
            //         {/* Banner Image Area */}
            //         <div className="relative h-44 bg-slate-800 overflow-hidden">
            //             <img
            //                 src="https://images.unsplash.com/photo-1545173168-9f19472ef7f4?auto=format&fit=crop&w=600&q=80"
            //                 alt="Laundromat washing machines"
            //                 className="w-full h-full object-cover opacity-80"
            //             />
            //             {/* Frosted Glass Header Overlay */}
            //             <div className="absolute bottom-0 inset-x-0 bg-white/30 backdrop-blur-md py-3 px-4 flex justify-between items-center border-t border-white/20">
            //                 <button className="text-teal-800 p-1 hover:bg-white/20 rounded-lg transition">
            //                     <Menu className="w-6 h-6" />
            //                 </button>
            //                 <span className="text-slate-800 font-semibold tracking-wide text-sm sm:text-base">
            //                     {/* {currentDate} */}
            //                 </span>
            //                 <div className="flex items-center gap-3">
            //                     <div className="relative w-9 h-9 bg-amber-100 rounded-full flex items-center justify-center border-2 border-amber-400 text-amber-700 font-bold text-xs shadow-sm">
            //                         DM
            //                         <span className="absolute -top-1.5 -right-1 text-[10px]">👑</span>
            //                     </div>
            //                     <button className="text-teal-900 hover:text-red-600 transition">
            //                         <Power className="w-5 h-5" />
            //                     </button>
            //                 </div>
            //             </div>
            //         </div>

            //         {/* Service Cards List */}
            //         <div className="p-4 space-y-4">
            //             {this.services.map((service) => {
            //                 const isDarkBg = service.isAction;
            //                 return (
            //                     <div
            //                         key={service.id}
            //                         className={`${service.bg} rounded-2xl p-4 flex items-center justify-between shadow-sm border border-slate-100 hover:shadow-md transition-all duration-200 cursor-pointer group`}
            //                     >
            //                         <div className="flex items-center gap-4">
            //                             {/* Left Icon Wrapper */}
            //                             <div className={`p-2.5 rounded-xl ${isDarkBg ? 'bg-white/20' : 'bg-teal-50 group-hover:bg-teal-100'} transition-colors`}>
            //                                 {service.icon}
            //                             </div>
            //                             {/* Text Content */}
            //                             <div>
            //                                 <h3 className={`font-bold text-sm tracking-wide ${isDarkBg ? 'text-white' : 'text-slate-800'}`}>
            //                                     {service.title} {service.subtitle && <span className="text-xs font-normal opacity-80">{service.subtitle}</span>}
            //                                 </h3>
            //                                 <p className={`text-xs mt-0.5 ${isDarkBg ? 'text-slate-200' : 'text-slate-500'}`}>
            //                                     {service.isLink ? (
            //                                         <span className="text-teal-600 underline font-medium hover:text-teal-700">{service.description}</span>
            //                                     ) : (
            //                                         service.description
            //                                     )}
            //                                 </p>
            //                             </div>
            //                         </div>

            //                         {/* Right Interactive Button */}
            //                         {!service.isLink && (
            //                             <button className={`p-1.5 rounded-full transition-transform group-hover:scale-110 ${isDarkBg
            //                                 ? 'bg-white/20 text-white hover:bg-white/30'
            //                                 : 'bg-teal-600 text-white hover:bg-teal-700'
            //                                 }`}>
            //                                 {isDarkBg ? <ChevronRight className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
            //                             </button>
            //                         )}
            //                     </div>
            //                 );
            //             })}
            //         </div>
            //     </div>

            //     {/* Bottom Home Indicator Bar (Simulating Mobile Viewport) */}
            //     <div className="w-32 h-1 bg-slate-300 rounded-full mx-auto mt-4"></div>
            // </div>

            <div className="container">

                <h1>Customer Orders</h1>
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <h1>React Web Push Demo</h1>
                    <button onClick={this.enablePushNotif}>
                        Enable Push Notifications
                    </button>
                </div>
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                    <h1>React Web Push Demo</h1>
                    <button onClick={this.sendPushNotiff}>
                        Send Push Notifications
                    </button>
                </div>
                <div style={{ paddingTop: "10px", fontSize: "15px" }}>
                    <FormGroup>
                        <FaSearch size={20} style={{ position: "absolute", marginLeft: "90%", marginTop: "10px" }} />
                        <Input
                            type='text'
                            id='searchOrders'
                            placeholder='Search by Phone number or Order ID'
                            onChange={this.setSearchTerm}
                            onKeyDown={this.clearSearchTerm}
                        />
                    </FormGroup>
                </div>
                <div style={{ padding: '20px' }}>
                    <h2>Dashboard {this.state.dynamicData}</h2>

                    <button
                        onClick={this.handleSendMessage}
                        // disabled={status !== 'Connected'}
                        style={{ padding: '10px 20px', cursor: 'pointer' }}
                    >
                        Send Click Event to Server
                    </button>
                </div>
                <Ordertable data={this.state.allCustomerOrders}
                    laststatus={this.getLastOrderStatus}
                    navigation={(orderid) => this.props.navigate('/orderdetails', {
                        state: {
                            orderid: orderid, fullname: this.state.fullname, emailaddress: this.state.emailaddress,
                            userid: this.state.userid, phonenumber: this.state.phonenumber, role: this.state.role, address:
                                this.state.address, area: this.state.area, city: this.state.city, page: this.state.page
                        }

                    })} />

                <div style={{ marginTop: "20px" }}>
                    <FormGroup>
                        <Label style={{ color: "#666", fontStyle: "italic" }} for='clothingweights'>Select weight</Label>
                        <Select
                            options={this.state.foldlist || []}
                            maxMenuHeight="100%"
                            defaultInputValue=""
                            onChange={opt => this.setClothingWeightsChange(opt.label)}

                        ></Select>
                    </FormGroup>

                </div>

            </div>
        );
    }
}
/////////


//////
export default withNavigateHook(Uat);
